export const breadcrumbName = {
  'course-introduction': 'แนะนำหลักสูตร',
  'department-science': 'สำนักวิชาวิทยาศาสตร์',
  'department-social': 'สำนักวิชาเทคโนโลยีสังคม',
  'department-agricultural': 'สำนักวิชาเทคโนโลยีการเกษตร',
  'department-engineering': 'สำนักวิชาวิศวกรรมศาสตร์',
  'department-medicine': 'สำนักวิชาแพทยศาสตร์',
  'department-nursing': 'สำนักวิชาพยาบาลศาสตร์',
  'department-dentistry': 'สำนักวิชาทันตแพทยศาสตร์',
  'department-public-health': 'สำนักวิชาสาธารณสุขศาสตร์',
  'department-degitech': 'สำนักวิชาศาสตร์และศิลป์ดิจิทัล',
  'department-chemical': 'สำนักวิชาเคมี',
  'department-biology': 'สำนักวิชาชีววิทยา',
  'department-sports-science': 'สำนักวิชาวิทยาศาสตร์การกีฬา',
  'department-mathematics': 'สำนักวิชาคณิตศาสตร์',
  'department-physics': 'สำนักวิชาวิชาฟิสิกส์',
  'department-geographical-informatics': 'สำนักวิชาวิชาภูมิสารสนเทศ',
  science: 'สาขาวิชาวิทยาศาสตร์',
  chemical: 'สาขาวิชาวิชาเคมี',
  biology: 'สาขาวิชาวิชาชีววิทยา',
  'sports-science': 'สาขาวิชาวิทยาศาสตร์การกีฬา',
  mathematics: 'หลักสูตรสาขาวิชาคณิตศาสตร์',
  physics: 'สาขาวิชาฟิสิกส์',
  'geographical-informatics': 'สาขาวิชาภูมิสารสนเทศ',
  'management-tectnology': 'หลักสูตรการจัดการบัณฑิต',
  'management-tectnology-innovation':
    'หลักสูตรการจัดการบัณฑิต สาขานวัตกรรมเทคโนโลยีอุตสาหกรรมบริการ',
  'crop-production-technology': 'สาขาวิชาเทคโนโลยีการผลิตพืช',
  'animal-technology-and-innovation': 'สาขาวิชาเทคโนโลยีและนวัตกรรมทางสัตว์',
  'food-technology': 'สาขาวิชาเทคโนโลยีอาหาร',
  'manufacturing-automation-and-robotics-engineering':
    'สาขาวิชาวิศวกรรมการผลิต',
  'agricultural-and-food-engineering': 'สาขาวิชาวิศวกรรมเกษตร',
  'transportation-and-logistics-engineering': 'สาขาวิชาวิศวกรรมขนส่ง',
  'computer-engineering': 'สาขาวิชาวิศวกรรมคอมพิวเตอร์',
  'chemical-engineering': 'สาขาวิชาวิศวกรรมเคมี',
  'ceramic-engineering': 'สาขาวิชาวิศวกรรมเซรามิก',
  'mechanical-engineering': 'สาขาวิชาวิศวกรรมเครื่องกล',
  'telecommunication-engineering': 'สาขาวิชาวิศวกรรมโทรคมนาคม',
  'polymer-engineering': 'สาขาวิชาวิศวกรรมพอลิเมอร์',
  'polymer-engineering-inter':
    'สาขาวิชาวิศวกรรมปิโตรเคมีและพอลิเมอร์ (นานาชาติ)',
  'electrical-engineering': 'สาขาวิชาวิศวกรรมไฟฟ้า',
  'civil-engineering': 'สาขาวิชาวิศวกรรมโยธา',
  'metallurgical-engineering': 'สาขาวิชาวิศวกรรมโลหการ',
  'environmental-engineering': 'สาขาวิชาวิศวกรรมสิ่งแวดล้อม',
  'industrial-engineering': 'สาขาวิชาวิศวกรรมอุตสาหการ',
  'geological-engineering': 'สาขาวิชาวิศวกรรมธรณี',
  'geological-engineering-petro': 'สาขาวิชาวิศวกรรมปิโตรเลียมและเทคโนโลยีธรณี',
  'electronic-engineering': 'สาขาวิชาวิศวกรรมอิเล็กทรอนิกส์',
  'material-innovation-and-design-engineering': 'สาขาวิชาเทคโนโลยีการออกแบบ',
  medicine: 'แพทยศาสตรบัณฑิต',
  'nursing-science': 'พยาบาลศาสตรบัณฑิต',
  'doctor-of-dental-surgery': 'ทันตแพทยศาสตรบัณฑิต',
  'environmental-health': 'สาขาวิชาอนามัยสิ่งแวดล้อม',
  'occupational-health-and-safety': 'สาขาวิชาอาชีวอนามัยและความปลอดภัย',
  'digital-technology': 'สาขาวิชาเทคโนโลยีดิจิทัล',
  'digital-communication': 'สาขาวิชานิเทศศาสตร์ดิจิทัล',
  enrollment: 'การลงทะเบียนเรียน',
  'registration-system': 'ขั้นตอนต่าง ๆ',
  'registered-credits': 'ขั้นตอนต่าง ๆ',
  'registered-GPAX': 'ขั้นตอนต่าง ๆ',
  'registration-fees': 'ขั้นตอนต่าง ๆ',
  'branch-selection': 'ขั้นตอนต่าง ๆ',
  'calculate-grade': 'ขั้นตอนต่าง ๆ',
  'request-to-move-branch': 'ขั้นตอนต่าง ๆ',
  're-entry': 'ขั้นตอนต่าง ๆ',
  'service-center': 'ขั้นตอนต่าง ๆ',
  'test-eng': 'ขั้นตอนต่าง ๆ',
  'retern-entry': 'ขั้นตอนต่าง ๆ',
  'technology-program-in-innovative-agripreneur':
    'หลักสูตรเทคโนโลยีบัณฑิต สาขาวิชาผู้ประกอบการเกษตรเชิงนวัตกรรม',
  'nutrition-and-dietetics': 'สาขาวิชาโภชนวิทยาและการกำหนดอาหาร',
  'nursing-science-60': 'พยาบาลศาสตรบัณฑิต หลักสูตรปรับปรุง 2560',
  'nursing-science-65': 'พยาบาลศาสตรบัณฑิต หลักสูตรปรับปรุง 2565',
  'precision-engineering': 'สาขาวิชาวิศวกรรมพรีซิชั่น',
  'mechatronics-engineering': 'สาขาวิชาวิศวกรรมเมคคาทรอนิกส์',
  micorbiology: 'สาขาวิชาจุลชีววิทยา',
  'medical-sciences': 'สาขาวิชาวิทยาศาสตร์การแพทย์',
  'computer-science': 'สาขาวิชาวิทยาการคอมพิวเตอร์',
  'automotive-and-aeronautical-engineering':
    'สาขาวิชาวิศวกรรมเครื่องกลและอากาศยาน (หลักสูตรนานาชาติ)',
  'civil-engineering-inter': 'สาขาวิชาวิศวกรรมโยธา (นานาชาติ)',
  'civil-and-infrastructure-engineering':
    'สาขาวิชาวิศวกรรมโยธาและโครงสร้างพื้นฐาน',
  'intelligent-embedded-engineering':
    'หลักสูตรวิชาวิศวกรรมสมองกลอัจฉริยะและอิเล็กทรอนิกส์ความถี่สูง',
  'industrial-electrical-engineering': 'สาขาวิชาวิศวกรรมไฟฟ้าอุตสาหกรรม',
  'electronics-and-embedded-system-egineering':
    'สาขาวิชาวิศวกรรมอิเล็กทรอนิกส์และระบบสมองกลฝังตัว',
  'automotive-engineering': 'สาขาวิชาวิศวกรรมยานยนต์สมัยใหม่',
  'mechanical-and-aeronautical-engineering':
    'สาขาวิชาวิศวกรรมเครื่องกลและอากาศยาน (หลักสูตรนานาชาติ)',
}

export const GotoSocial = (key) => {
  const social = {
    fb: 'https://www.facebook.com/sutnews',
    tw: 'https://twitter.com/sutnews',
    tt: 'https://www.tiktok.com/@sut_tiktok?is_from_webapp=1&sender_device=pc',
  }
  window.open(social[key], '_blank')
}

export const WebsiteEngi = {
  สาขาวิชาวิศวกรรมเกษตรและอาหาร:
    "https://eng.sut.ac.th/ENG2023/undergraduate-study/beng-in-agricultural-and-food-engineering/",
  สาขาวิชาวิศวกรรมเซรามิก:
    "https://eng.sut.ac.th/ENG2023/undergraduate-study/beng-in-ceramic-engineering/",
  สาขาวิชาวิศวกรรมเคมี:
    "https://eng.sut.ac.th/ENG2023/undergraduate-study/beng-in-chemical-engineering/",
  สาขาวิชาวิศวกรรมโยธา:
    "https://eng.sut.ac.th/ENG2023/beng-in-civil-engineering",
  สาขาวิชาวิศวกรรมคอมพิวเตอร์:
    "https://eng.sut.ac.th/ENG2023/undergraduate-study/beng-in-computer-engineering/",
  สาขาวิชาวิศวกรรมไฟฟ้า:
    "https://eng.sut.ac.th/ENG2023/undergraduate-study/beng-in-electrical-engineering/",
  สาขาวิชาวิศวกรรมอิเล็กทรอนิกส์และระบบสมองกลฝังตัว:
    "https://eng.sut.ac.th/ENG2023/undergraduate-study/beng-in-electronics-and-embedded-system-engineering/",
  สาขาวิชาวิศวกรรมสิ่งแวดล้อม:
    "https://eng.sut.ac.th/ENG2023/undergraduate-study/beng-in-environmental-engineering/",
  สาขาวิชาวิศวกรรมธรณี:
    "https://eng.sut.ac.th/ENG2023/undergraduate-study/beng-in-geological-engineering/",
  สาขาวิชาวิศวกรรมอุตสาหการ:
    "https://eng.sut.ac.th/ENG2023/undergraduate-study/beng-in-industrial-engineering/",
  สาขาวิศวกรรมการผลิตอัจฉริยะ:
    "https://eng.sut.ac.th/ENG2023/undergraduate-study/beng-in-intelligent-manufacturing-engineering/",
  สาขาวิชาวิศวกรรมเครื่องกล:
    "https://eng.sut.ac.th/ENG2023/undergraduate-study/beng-in-mechanical-engineering/",
  สาขาวิชาวิศวกรรมโลหการ:
    "https://eng.sut.ac.th/ENG2023/undergraduate-study/beng-in-metallurgical-engineering/",
  สาขาวิชาวิศวกรรมปิโตรเลียมและเทคโนโลยีธรณี:
    "https://eng.sut.ac.th/ENG2023/undergraduate-study/#",
  สาขาวิชาวิศวกรรมพอลิเมอร์:
    "https://eng.sut.ac.th/ENG2023/undergraduate-study/beng-in-polymer-engineering/",
  สาขาวิชาวิศวกรรมโทรคมนาคมและโครงข่ายอัจฉริยะ:
    "https://eng.sut.ac.th/ENG2023/beng-in-telecommunication-and-intelligent-network-engineering/",
  สาขาวิชาวิศวกรรมขนส่งและโลจิสติกส์:
    "https://eng.sut.ac.th/ENG2023/undergraduate-study/beng-in-transportation-and-logistics-engineering/",
  "สาขาวิชาวิศวกรรมโยธาและโครงสร้างพื้นฐาน (หลักสูตรนอกเวลา)":
    "https://eng.sut.ac.th/ENG2023/beng-in-civil-and-infrastructure-engineering/",
  "สาขาวิชาการประกอบการด้วยเทคโนโลยีดิจิทัล (หลักสูตรนอกเวลา)":
    "https://eng.sut.ac.th/ENG2023/undergraduate-study/beng-in-digital-technology-entrepreneurship/",
  "สาขาวิชาวิศวกรรมไฟฟ้าอุตสาหกรรม (หลักสูตรนอกเวลา)":
    "https://eng.sut.ac.th/ENG2023/undergraduate-study/beng-in-industrial-electrical-engineering/",
  "สาขาวิชาวิศวกรรมอุตสาหการและการจัดการข้อมูล (หลักสูตรนอกเวลา)":
    "https://eng.sut.ac.th/ENG2023/beng-in-industrial-engineering-and-data-management",
  "สาขาวิชาวิศวกรรมระบบสมองกลอัจฉริยะและอิเล็กทรอนิกส์ความถี่สูง (หลักสูตรนอกเวลา)":
    "https://eng.sut.ac.th/ENG2023/beng-in-intelligent-embedded-systems-and-high-frequency-electronic-engineering/",
  "สาขาวิชาวิศวกรรมเครื่องกลและกระบวนการผลิต (หลักสูตรนอกเวลา)":
    "https://eng.sut.ac.th/ENG2023/beng-in-mechanical-engineering-and-production-system",
  "สาขาวิชาวิศวกรรมเมคคาทรอนิกส์ (หลักสูตรนอกเวลา)":
    "https://eng.sut.ac.th/ENG2023/undergraduate-study/beng-in-mechatronics-engineering/",
  "สาขาวิชาวิศวกรรมยานยนต์สมัยใหม่ (หลักสูตรนอกเวลา)":
    "https://eng.sut.ac.th/ENG2023/undergraduate-study/beng-in-modern-automotive-engineering/",
  "สาขาวิชาวิศวกรรมโยธา (หลักสูตรนานาชาติ)":
    "https://eng.sut.ac.th/ENG2023/beng-in-civil-engineering-international-program",
  "สาขาวิชาวิศวกรรมเครื่องกลและอากาศยาน (หลักสูตรนานาชาติ)":
    "https://eng.sut.ac.th/ENG2023/undergraduate-study/beng-in-mechanical-and-aeronautical-engineering-international-program/",
  "สาขาวิชาวิศวกรรมปิโตรเคมีและพอลิเมอร์ (หลักสูตรนานาชาติ)":
    "https://eng.sut.ac.th/ENG2023/beng-in-petrochemical-and-polymer-engineering-international-program",
};

export const ListColorContact = {
  "department-science": "#FFE346",
  "department-social": "#4675B5",
  "department-agricultural": "#5abc73",
  "department-engineering": "#761416",
  "department-medicine": "#176543",
  "department-nursing": "#313778",
  "department-dentistry": "#774f9f",
  "department-public-health": "#ee4590",
  "department-degitech": "#1f40b1",
};

export const ListColor1 = {
  "department-science": "#FFE346",
  "department-social": "#4675B5",
  "department-agricultural": "#f7d785",
  "department-engineering": "#761416",
  "department-medicine": "#306346",
  "department-nursing": "#7f87bd",
  "department-dentistry": "#a591be",
  "department-public-health": "#55AF49",
  "department-degitech": "#4FE29D",
};

export const ListColor2 = {
  "department-science": "#FFFAE6",
  "department-social": "#edf1f6",
  "department-agricultural": "#f0f7ed",
  "department-engineering": "#fafbfb",
  "department-medicine": "#f0f7ed",
  "department-nursing": "#f2f3f8",
  "department-dentistry": "#fdfcfa",
  "department-public-health": "#fff3f8",
  "department-degitech": "#ecf5f8",
};

export const ListColorQ = {
  "department-dentistry": "#774f9f",
  "department-medicine": "#176543",
};

export const ListContact = {
  "department-science":
    "ข้อมูลติดต่อหลักสูตร/หน่วยงาน ภายในสำนักวิชาวิทยาศาสตร์",
  "department-social": "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาเทคโนโลยีสังคม",
  "department-agricultural":
    "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาเทคโนโลยีการเกษตร",
  "department-engineering":
    "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาวิศวกรรมศาสตร์",
  "department-medicine": "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาแพทยศาสตร์",
  "department-nursing": "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาพยาบาลศาสตร์",
  "department-dentistry": "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาทันตแพทยศาสตร์",
  "department-public-health":
    "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาสาธารณสุขศาสตร์",
  "department-degitech":
    "ข้อมูลติดต่อหน่วยงานภายในสำนักวิชาศาสตร์และศิลป์ดิจิทัล",
};

export const ListView = {
  "department-science": "คู่มือสำนักวิชาวิทยาศาสตร์มีคนเข้ามาดูแล้ว",
  "department-social": "คู่มือสำนักวิชาเทคโนโลยีสังคมมีคนเข้ามาดูแล้ว",
  "department-agricultural":
    "คู่มือสำนักวิชาเทคโนโลยีการเกษตรมีคนเข้ามาดูแล้ว",
  "department-engineering": "คู่มือสำนักวิชาวิศวกรรมศาสตร์มีคนเข้ามาดูแล้ว",
  "department-medicine": "คู่มือสำนักวิชาแพทยศาสตร์มีคนเข้ามาดูแล้ว",
  "department-nursing": "คู่มือสำนักวิชาพยาบาลศาสตร์มีคนเข้ามาดูแล้ว",
  "department-dentistry": "คู่มือสำนักวิชาทันตแพทยศาสตร์มีคนเข้ามาดูแล้ว",
  "department-public-health":
    "คู่มือสำนักวิชาสาธารณสุขศาสตร์มีคนเข้ามาดูแล้ว",
  "department-degitech":
    "คู่มือสำนักวิชาศาสตร์และศิลป์ดิจิทัลมีคนเข้ามาดูแล้ว",
};
